<div>
  <div style="margin-left: 70%; margin-bottom: 2%">
    <!-- <button printSectionId="print-section" mat-raised-button color="primary" ngxPrint [useExistingCss]="true" class="noPrint">
      Print
    </button> -->
    <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
  </div>

  <div class="container" id="print-section">
    <!-- Outer Border -->
    <div>

      <!-- Header -->
      <div class="row" style="text-align: center; background-color: black;">
        <h3 style="color: white; margin: auto;">TAX ORDER</h3>
      </div>

      <!-- Logo & Title -->
    <div class="row">
        <div class="col-9 topheader">
          <span class="fontBold">हिंदुस्थान प्रकाशन संस्था</span>
          <span><span class="heading1">साप्ताहिक विवेक - पुस्तक विभाग</span></span>
          <span>मुख्य कार्यालय: 5/12, कामत औद्योगिक वसाहत, 396 स्वा. वीर सावरकर मार्ग, प्रभादेवी, मुंबई-25.</span>
          <span>प्रशासकीय कार्यालय: विवेक भवन (कृष्णा रिजन्सी), 12 वा मजला, प्लॉट क्र. 40, सेक्टर क्र. 30, सानपाडा (प.), नवी मुंबई-400 705.</span>
          <span>दूरध्वनी: 27810235 / 236 | मोबाईल: 9594961836 | Email: vivekbookdept&#64;gmail.com</span>
        </div>
        <div class="col-3 flex">
          <img src="../../../assets/img/brand/red.png" alt="Logo" />
        </div>
      </div>

      <!-- GST & PAN -->
      <div class="row">
        <div class="col-6">
          <b>GSTIN/Unique Id :</b> 27AAATH0433Q1ZI
        </div>
        <div class="col-6">
          <b>PAN No. :</b> AAATH0433Q
        </div>
      </div>

      <!-- Order Info -->
      <div class="row">
        <div class="col-6">
          <b>Order No. :</b> {{ bookinvoice[0]?.oder_no }}
        </div>
        <div class="col-6">
          <!-- <b>Order Date :</b> {{ bookinvoice[0]?.booking_date | date: "dd-MM-yyyy" }} -->
        </div>
      </div>

      <!-- Receiver & Consignee -->
      <div class="row">
        <div class="col-6">
          <h3 style="font-weight: bold;">Details of Receiver :</h3>
          <span class="receiver">Name: <strong>{{ bookinvoice[0]?.receiver_name }}</strong></span>
          <span class="receiver">Address: {{ bookinvoice[0]?.addresss }}, {{ bookinvoice[0]?.taluka }}, {{ bookinvoice[0]?.district }}, {{ bookinvoice[0]?.state }}, {{ bookinvoice[0]?.country }}, {{ bookinvoice[0]?.pincode }}</span>
          <span class="receiver">Phone: {{ bookinvoice[0]?.mobile_no }}</span>
          <span class="receiver">GSTIN: {{ bookinvoice[0]?.gst }}</span>
        </div>
        <div class="col-6">
          <h3 style="font-weight: bold;">Details of Consignee :</h3>
          <span class="receiver">Name:</span>
          <span class="receiver">Address:</span>
          <span class="receiver">Phone:</span>
          <span class="receiver">GSTIN:</span>
        </div>
      </div>

      <!-- Table Header -->
      <div class="row">
        <div class="col-1 tableDescheader">S.No</div>
        <div class="col-3 tableDescheader">Book Name</div>
        <div class="col-1 tableDescheader">HSN Code</div>
        <div class="col-1 tableDescheader">Book Price</div>
        <div class="col-1 tableDescheader">Book Sale Price</div>
        <div class="col-1 tableDescheader">Discount Amount</div>
        <div class="col-1 tableDescheader">Net Amount</div>
        <div class="col-1 tableDescheader">Book Copies</div>
        <div class="col-2 tableDescheader">Total Taxable Value</div>
      </div>

      <!-- Table Data -->
      <div class="row" *ngFor="let item of bookinvoicedata; let i = index">
        <div class="col-1 tableDesc">{{ i + 1 }}</div>
        <div class="col-3 tableDesc" style="text-align: left;">{{ item.book_name }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">4902</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item.book_price }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item.book_sale_price }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item.discountamt }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item.totalafterdiscount }}</div>
        <div class="col-1 tableDesc" style="text-align: right;">{{ item.book_copies }}</div>
        <div class="col-2 tableDesc" style="text-align: right;">{{ item.total }}</div>
      </div>

      <!-- Totals -->
      <div class="row">
        <div class="col-8 heading1">
          <b>Order Total in Words:</b> {{ amtinwords }}
        </div>
        <div class="col-4">
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>CGST :</span><span>{{ bookinvoice[0]?.cgst }}</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>SGST :</span><span>{{ bookinvoice[0]?.sgst }}</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>IGST :</span><span>{{ bookinvoice[0]?.igst }}</span></div>
          <div class="spacebet" style="padding: 6px 8px;"><span>Total GST :</span><span>{{ bookinvoice[0]?.gstamount }}</span></div>
        </div>
      </div>

      <!-- Bank Details & Amount -->
      <div class="row">
        <div class="col-8" style="display: flex; justify-content: space-between;">
          <div>
            <b>Bank Details:</b><br>
            A/C Name - HINDUSTAN PRAKASHAN SANSTHA<br>
            A/C No. - 20109800154<br>
            IFSC No. - MAHB0000318<br>
            Bank Name - Bank of Maharashtra<br>
            Branch - Prabhadevi, Mumbai - 400025
          </div>
          <div>
            <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code" class="qr-code" />
          </div>
        </div>
        <div class="col-4">
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Total :</span><span>{{ total_amount }}</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Shipping Charges :</span><span>{{ shipping_charges }}</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Round Off :</span><span>0</span></div>
          <div class="spacebet" style="border-bottom: 2px solid black; padding: 6px 8px;"><span>Invoice Total :</span><span>{{ totals }}</span></div>
          <div class="spacebet" style="font-weight: 500; padding: 6px 8px;"><span>Total Dues :</span><span>{{ totals }}</span></div>
        </div>
      </div>

      <!-- Terms & Signatory -->
      <div class="row">
        <div class="col-8 flexbox" style="padding: 15px;">
          <h2>Terms:</h2>
          <span>1) Complaints of any nature must be communicated in writing within 10 Days from the date of delivery.</span>
          <span>2) A/C payee cheques to be drawn in favor of :-</span>
          <span>हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग</span>
        </div>
        <div class="col-4 flexadd" style="padding: 15px;">
          <span style="font-size: 1.2rem; font-weight: 700;">हिंदुस्थान प्रकाशन संस्था</span>
          <div style="height: 80px;"></div>
          <div style="text-align: center;"><span>Authorised Signatory</span></div>
        </div>
      </div>

    </div>
  </div>
</div>
